export default __webpack_public_path__ + "static/media/ic_tlp1_24.63c606c5.svg";